import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NoteUpd } from '../../models/NoteUpd';
import { ConfirmOutput } from '../../models/ConfirmOutput';
import { CPDialogResult } from '../../enums/CPDialogResult';
import { CRUDActions } from '../../enums/CRUDActions';
import { CommonFunctions } from '../../static/common-functions';

export class ConfirmDialogOptions {

    title?: string = null;
    message?: string = null;
    action?: CRUDActions = CRUDActions.None;
    data?: any = null;
    code?: string = null;
    okButtonOnly: boolean = false;
    okButtonText?: string;
    cancelButtonText?: string;
}

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent {

    constructor() {
    }
    active: boolean = false;
    data: any;
    action: CRUDActions;
    @Input() title: string;
    @Input() message: string;
    messages: string[];
    messageMode: number = 0; //0 Normal, 1-Multiple, 2-Input
    dialogWidth: number = 450;
    code: string;
    note: string;
    customValue: any;
    customValueType: number = 1; //1-Number, 2-String, 3-Note
    showCancelButton: boolean = true;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() yesNo: boolean;
    @Input() okString: string = "Ok";
    @Input() cancelString: string = "Cancel";
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;
        this.note = null;
    }
    ok() {
        let retData: any = this.data;
        if (this.messageMode == 2) {
            retData = this.customValueType == 3 ? this.note : this.customValue;
        }
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.ok, data: retData, code: this.code };
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code };
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code };
        this.confirmation.emit(result);
        this.hide();
    }
    public show(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code = null, okButtonOnly = false, yesNo: boolean = false) {
        this.data = data;
        this.action = action;
        if (yesNo) {
            this.okString = "Yes";
            this.cancelString = "No";
        }
        this.title = CommonFunctions.getStringValueIfNull(title, "Please Confirm");
        this.message = message;
        this.code = code;
        if (okButtonOnly) {
            this.showCancelButton = false;
        }
        this.active = true;
    }

    public showWithOverrides(options: Partial<ConfirmDialogOptions>) {
        this.data = options.data;
        this.action = options.action;
        if (options.okButtonText) {
            this.okString = options.okButtonText;
        }
        if (options.cancelButtonText) {
            this.cancelString = options.cancelButtonText;
        }
        if (options.title) {
            this.title = options.title;
        }
        if (options.message) {
            this.message = options.message;
        }
        if (options.code) {
            this.code = options.code;
        }
        if (options.okButtonOnly) {
            this.showCancelButton = false;
        }
        this.active = true;
    }
    public showMessages(messages: string[], title: string = null, width: number = null) {
        this.title = CommonFunctions.getStringValueIfNull(title, "Please Confirm");
        this.messages = messages;
        this.messageMode = 1;
        this.showCancelButton = false;
        if (CommonFunctions.hasNumberValue(width)) {
            this.dialogWidth = width;
        }
        this.active = true;
    }
    public showNote(note: string, title: string = null, width: number = null) {
        this.title = CommonFunctions.getStringValueIfNull(title, "Enter Required Reason");
        this.note = note;
        this.messageMode = 2;
        this.customValueType = 3;
        this.showCancelButton = true;
        if (CommonFunctions.hasNumberValue(width)) {
            this.dialogWidth = width;
        }
        this.active = true;
    }

    public showCustomValue(value: any, valueType: number = 1, title: string = null, width: number = null) {
        this.title = CommonFunctions.getStringValueIfNull(title, "Enter Value");
        this.customValue = value;
        this.customValueType = valueType;
        this.messageMode = 2;
        this.showCancelButton = true;
        if (CommonFunctions.hasNumberValue(width)) {
            this.dialogWidth = width;
        }
        this.active = true;
    }
}

